import { JetView } from 'webix-jet';
import { devConfig } from '../../config/config';
import { players } from '../../models/players-model';

/**
 * Class representing the view for adding a machine register.
 * Extends the JetView class from webix-jet.
 */
export default class addMachineRegisterView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const lenguages = [
            // Language options for selection
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
        ];

        // Main form configuration
        const main = {
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text',
                            name: 'LoginAccess', // Field for login access
                            label: _('Login para acceso'),
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'),
                            required: true,
                            invalidMessage: _('Campo Requerido'), // Error message for required field
                        },
                        {
                            view: 'text',
                            name: 'Password', // Field for password
                            label: _('Clave'),
                            labelPosition: 'top',
                            placeholder: _('Clave'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'State', // Field for state selection
                            localId: 'State:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'R', value: _('Retirado') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'PreferredLanguage', // Field for preferred language selection
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: lenguages,
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Name', // Field for user name
                            label: "<span class='icon-user'></span>" + _('Nombre del usuario'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'CountryId', // Field for country selection
                            id: 'country',
                            localId: 'Country:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'CurrencyId', // Field for currency selection
                            id: 'currency',
                            localId: 'Currency:combo',
                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };

        // Options main form configuration
        const options_main = {
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'richselect',
                            name: 'SpecialStatus', // Field for special status selection
                            localId: 'SpecialStatus:combo',
                            label: _('Estado especial'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'Pinagent', // Field for pin agent selection
                            localId: 'Pinagent:combo',
                            label: _('Pinagent'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'Lockedsales', // Field for locked sales selection
                            localId: 'Lockedsales:combo',
                            label: _('Bloqueado para ventas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'PrintReceiptBox', // Field for print receipt box selection
                            localId: 'PrintReceiptBox:combo',
                            label: _('Imprime recibo caja'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'AllowsRecharges', // Field for allowing recharges selection
                            localId: 'AllowsRecharges:combo',
                            label: _('Permite recargas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'ActivateRegistration', // Field for activating registration selection
                            localId: 'ActivateRegistration:combo',
                            label: _('Permite activar reg'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'S', value: _('Si') },
                                { id: 'N', value: _('No') },
                            ],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Latitud', // Field for latitude input
                            type: 'number',
                            label: _('Latitud'),
                            labelPosition: 'top',
                            placeholder: _('Latitud'),
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Longitud', // Field for longitude input
                            type: 'number',
                            label: _('Longitud'),
                            labelPosition: 'top',
                            placeholder: _('Longitud'),
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'IP', // Field for IP address input
                            label: _('IP'),
                            labelPosition: 'top',
                            placeholder: _('IP'),
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };

        // Betshop details form configuration
        const betshop_details = {
            margin: 5,
            id: 'betshop_details',
            padding: 15,
            minWidth: 250,
            cols: [
                {
                    rows: [
                        {
                            view: 'text',
                            name: 'ContactName', // Field for contact name input
                            label: _('Nombre del contacto'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del contacto'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Email', // Field for email input
                            label: _('Correo electrónico'),
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'),
                            required: true,
                            invalidMessage: 'Campo inválido',
                        },
                        {
                            view: 'text',
                            name: 'Description', // Field for description input
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'),
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'ManagerPhone', // Field for manager phone input
                            type: 'number',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'Concessionaire', // Field for concessionaire selection
                            id: 'Concessionaire',
                            localId: 'Concessionaire:combo',
                            label: _('Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'Subconcessionaire', // Field for subconcessionaire selection
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'RegionId', // Field for region selection
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'CityId', // Field for city selection
                            id: 'City',
                            localId: 'City:combo',
                            label: "<span class='icon-language'></span>" + _('Ciudad'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Address', // Field for address input
                            label: _('Dirección'),
                            labelPosition: 'top',
                            placeholder: _('Dirección'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'District', // Field for district input
                            label: _('Barrio'),
                            labelPosition: 'top',
                            placeholder: _('Barrio'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'MobilePhone', // Field for mobile phone input
                            type: 'number',
                            label: _('Teléfono Mobile'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono Mobile'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };

        // Center right section configuration
        const center_right = {
            padding: 15,
            margin: 15,
            cols: [
                {
                    rows: [
                        {
                            view: 'text',
                            name: 'DailyQuotaReloads', // Field for daily quota reloads input
                            type: 'number',
                            label: _('Limite diario de recargas'),
                            labelPosition: 'top',
                            placeholder: _('Limite diario de recargas'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'CommissionReloads', // Field for commission reloads input
                            type: 'number',
                            label: _('Comisión recargas'),
                            labelPosition: 'top',
                            placeholder: _('Comisión recargas'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'MinimumBet', // Field for minimum bet input
                            type: 'number',
                            label: _('Apuesta mínima'),
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'DailyLimit', // Field for daily limit input
                            type: 'number',
                            label: _('Límite diario'),
                            labelPosition: 'top',
                            placeholder: _('Límite diario'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };

        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section configuration with accordions
        const upper_section = {
            id: 'b5',
            rows: [
                {
                    collapsed: true,
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    cols: [
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Principales'),
                                    body: {
                                        rows: [main],
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Configuración'),
                                    body: {
                                        rows: [options_main],
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Punto de venta'),
                                    body: {
                                        rows: [betshop_details],
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Configuración Punto de Venta'),
                                    body: {
                                        rows: [center_right],
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Button configuration for form actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Guardar'), // Save button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newdata = this.getRoot().getValues(); // Get form values
                            console.log(newdata);
                            this.app.callEvent('betshop:save', [newdata]); // Trigger save event
                        } else {
                            webix.message({
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('Completa los campos...'), // Error message for incomplete fields
                            });
                        }
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            view: 'form',
            id: 'formId', // Form ID
            scroll: 'y', // Enable vertical scrolling
            css: 'out',
            rows: [buttons, upper_section], // Form structure
            rules: {
                Email: webix.rules.isEmail, // Email validation rule
            },
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        this.validate(); // Validate on change
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} form - The form object.
     */
    init(form) {
        // Fetch countries for the country selection
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message for failed request
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"'));
                    var optionsProvinceRegions = $$('country').getList();
                    optionsProvinceRegions.clearAll(); // Clear previous options
                    optionsProvinceRegions.parse(data.Data); // Parse new options
                },
            });

        // Fetch agents for the concessionaire selection
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels2', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message for failed request
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"'));
                    if (data.Data.Children == null) {
                        $$('Concessionaire').hide(); // Hide if no children
                        $$('Subconcessionaire').hide();
                    } else {
                        var options = $$('Concessionaire').getList();
                        options.clearAll(); // Clear previous options
                        options.parse(data.Data.Children); // Parse new options
                    }
                },
            });

        this.app.callEvent('form:update', [this.getParam('user', true)]); // Update form with user data

        // Event handlers for updating form values
        this.on(this.app, 'customer:updatedata', (person) => form.setValues(person));
        this.on(this.app, 'person:select', (person) => form.setValues(person));
        this.on(this.app, 'betshop:save', (data) => {
            // Save machine data
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'BetShop/SaveMachine', data, {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error'); // Error message for failed save
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var json = JSON.parse(text);
                        webix.message('Saved'); // Success message
                        this.show('betShopManagement?user=' + json.id + '/betShopManagement.informationBetShop'); // Redirect to management page
                    },
                });
        });

        // Event handler for country selection change
        $$('country').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv);
            var optionscurrencies = $$('currency').getList();
            optionscurrencies.clearAll(); // Clear previous currency options
            optionscurrencies.parse(optionscountries.currencies); // Parse new currency options
            var optionsProvinceRegions = $$('ProvinceRegion').getList();
            optionsProvinceRegions.clearAll(); // Clear previous province options
            optionsProvinceRegions.parse(optionscountries.departments); // Parse new province options
        });

        // Event handler for province selection change
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv);
            var optionsCity = $$('City').getList();
            optionsCity.clearAll(); // Clear previous city options
            optionsCity.parse(optionsProvinceRegions.cities); // Parse new city options
        });

        // Event handler for concessionaire selection change
        $$('Concessionaire').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv);
            var optionsCity = $$('Subconcessionaire').getList();
            optionsCity.clearAll(); // Clear previous subconcessionaire options
            optionsCity.parse(optionsProvinceRegions.Children); // Parse new subconcessionaire options
        });
    }

    /**
     * Retrieves localized options for combo boxes.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parse position options

        let t_options = webix.copy(getTags()); // Get tags
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parse tag options

        let c_options = webix.copy(getCities()); // Get cities
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parse city options
    }
}

// FILE DOCUMENTED
